import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

interface TextCellProps {
  row: any;
  column: any;
  className: string;
  style?: React.CSSProperties;
}
/**
 * Text cell with truncate and tooltip
 *
 */
export const TextCell = (props: Readonly<TextCellProps>): JSX.Element => {
  const { row, column, className, style } = props;
  const [ toggleTooltip, setToggleTooltip ] = useState(false);
  const compId = `r${row.index}-l${column.id}-toggle`;
  return (
    <React.Fragment>
      <span id={compId}  data-toggle="tooltip" className={className} style={style}>
        {row.values[column.id]}
      </span>
      <Tooltip target={compId} isOpen={toggleTooltip} toggle={() => setToggleTooltip(!toggleTooltip)}>
        {row.values[column.id]}
      </Tooltip>
    </React.Fragment>

  );
}
TextCell.displayName = 'TextCell';
